export default __webpack_public_path__ + "static/media/Sauveteur_secouriste_du_travail_Logo.svg.6da249b0.png";